import React, { useState } from "react";
import Clock from "../../assets/icons/Clock Icon.svg";
import xIcon from "../../assets/icons/x-circle.svg";
import searchIcon from "../../assets/icons/search.svg";
import deleteIcon from "../../assets/icons/Bin.svg";

import {
  fetchTask,
  FetchClientsByCompany,
  AddComments,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";

const Dependency = ({
  translation1,
  translation2,
  translation3,
  translation4,
  showDependencyDrop,
  dependenciesRef,
  allTasks,
  dependencyList,
  setDependencyList,
  setChangeComp,
  setShowDependencyDrop,
  setTaskId,
  taskId,
}) => {
  const dispatch = useDispatch();
  const [linkATask, setLinkATask] = useState(true);
  const [searchdiv, setSearchdiv] = useState(false);
  const [dependencySearch, setDependencySearch] = useState("");
  const roleAccess = window.localStorage.getItem("roleid");

  return (
    <div
      className="task-modal-dependencies-new-box"
      style={{ marginTop: "2rem" }}
    >
      <div className="task-modal-dependencies-box-1 frcb">
        <p className="mb-0">{translation1}</p>
        {linkATask ? (
          <p
            className="mb-0"
            style={{
              cursor:
                roleAccess === process.env.REACT_APP_IS_VIEWER
                  ? "default"
                  : "cursor",
            }}
            onClick={() => {
              if (roleAccess === process.env.REACT_APP_IS_VIEWER) return;
              setSearchdiv(!searchdiv);
              setLinkATask(false);
            }}
          >
            {translation2}
          </p>
        ) : (
          <img
            alt=""
            className="x-icon-pop"
            src={xIcon}
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSearchdiv(!searchdiv);
              setLinkATask(true);
            }}
          />
        )}
      </div>
      <div style={{ padding: "0.5rem 2rem" }}>
        <div className="fc task-modal-new-dependencies-list-box">
          {searchdiv && (
            <div
              className="frc task-modal-new-dependency"
              style={{ columnGap: "1rem" }}
            >
              <div
                className="frc py-2"
                style={{ columnGap: "0.5rem", flexShrink: 0 }}
              >
                <img
                  alt=""
                  src={Clock}
                  style={{
                    minWidth: "18px",
                    minHeight: "18px",
                    width: "22px",
                    height: "22px",
                  }}
                />
                <div
                  className="wait-text "
                  style={{
                    color: "#333333",
                    fontSize: "14px",
                  }}
                >
                  {translation3}
                </div>
              </div>
              <div className="task-modal-new-dependency-search-box frc">
                <img
                  alt=""
                  className="search_pop"
                  style={{ opacity: 0.5 }}
                  src={searchIcon}
                />
                <p
                  className="mb-0"
                  style={{ opacity: 0.5, flexGrow: 1 }}
                  onClick={() => setShowDependencyDrop(true)}
                >
                  {translation4}
                </p>
                {showDependencyDrop && (
                  <div
                    className="task-modal-new-dependency-search-main"
                    ref={dependenciesRef}
                  >
                    <div className="task-modal-new-dep-search-div frc">
                      <img className="search_pop" src={searchIcon} alt="" />
                      <input
                        className="task-modal-new-dep-search-input"
                        type="text"
                        value={dependencySearch}
                        style={{
                          opacity: !dependencySearch && 0.5,
                        }}
                        placeholder={translation4}
                        onChange={(e) => {
                          setChangeComp(e.target.value);
                          setDependencySearch(e.target.value);
                        }}
                      />
                    </div>
                    <div
                      className="fc my-2"
                      style={{
                        padding: "0 20px",
                        maxHeight: "150px",
                        overflow: "auto",
                      }}
                    >
                      {allTasks?.map((block, blockIndex) => (
                        <div key={`allTasks-${blockIndex}`}>
                          {block.taskdetails.map(
                            (taskDetail, taskDetailIndex) => (
                              <div key={`taskDetail-${taskDetailIndex}`}>
                                {taskDetail.tasks
                                  .filter((task) => {
                                    if (task?.taskid === taskId) return;
                                    // Filter tasks based on statusid
                                    return !(
                                      task.statusid &&
                                      (task.statusid ===
                                        process.env
                                          .REACT_APP_TASK_STATUS_COMPLETE ||
                                        task.statusid ===
                                          "08dab011-a6cf-4069-887e-83e5f3473108" ||
                                        task.statusid ===
                                          process.env
                                            .REACT_APP_PROJECT_FOR_PODUCTION)
                                    );
                                  })
                                  .map((task, taskIndex) => (
                                    <div key={`task-${taskIndex}`}>
                                      {task &&
                                      task.taskname
                                        ?.toLowerCase()
                                        .includes(
                                          dependencySearch.toLowerCase(),
                                        ) ? (
                                        <p
                                          className="mb-0"
                                          style={{
                                            fontWeight: 500,
                                            textTransform: "capitalize",
                                          }}
                                          onClick={() => {
                                            if (
                                              dependencyList?.find(
                                                (item) =>
                                                  item.dependenciesid ===
                                                  task.taskid,
                                              )
                                            ) {
                                              return;
                                            } else {
                                              const item = {
                                                dependenciesid: task.taskid,
                                                dependenciesname: task.taskname,
                                              };
                                              setDependencyList([
                                                ...dependencyList,
                                                item,
                                              ]);
                                              setShowDependencyDrop(false);
                                              setChangeComp(item);
                                            }
                                          }}
                                        >
                                          {task?.taskname}
                                        </p>
                                      ) : null}
                                    </div>
                                  ))}
                              </div>
                            ),
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {dependencyList?.map((dependency, index) => (
            <div
              className="frcb py-2 task-modal-new-dependency"
              key={`dependencies-${dependency.dependenciesid}-${index}`}
            >
              <div className="frc" style={{ columnGap: "1rem" }}>
                <div className="frc" style={{ columnGap: "0.5rem" }}>
                  <img
                    alt=""
                    src={Clock}
                    style={{
                      minWidth: "18px",
                      minHeight: "18px",
                      width: "22px",
                      height: "22px",
                    }}
                  />
                  <div className="wait-text " style={{ color: "#333333" }}>
                    {translation3}
                  </div>
                </div>
                <div
                  className="task-modal-new-dependency-text"
                  style={{
                    cursor:
                      roleAccess === process.env.REACT_APP_IS_VIEWER
                        ? "default"
                        : "pointer",
                    textTransform: "capitalize",
                  }}
                  onClick={() => {
                    // window.open(`planboard`, "_blank");
                    dispatch(fetchTask(dependency.dependenciesid));
                    setTaskId(dependency.dependenciesid);
                    // localStorage.setItem("linkedDependencyID", dependency.dependenciesid);
                  }}
                >
                  {dependency.dependenciesname}
                </div>
              </div>
              <img
                alt=""
                className={
                  roleAccess === process.env.REACT_APP_IS_VIEWER
                    ? "pointerEvent"
                    : ""
                }
                src={deleteIcon}
                style={{
                  opacity: "50%",
                  cursor: "pointer",
                  width: "16px",
                }}
                onClick={() => {
                  let list = [...dependencyList];
                  list = list.filter((item) => {
                    return item.dependenciesid !== dependency.dependenciesid;
                  });
                  setDependencyList(list);
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dependency;
